import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {DataTablesResponse} from "../models/dataTables-response";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TypeProductService {

    constructor(private http: HttpClient) { }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}type-products/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}type-products`).pipe(map(response => {
            return response;
        }));
    }

    getById(typeProductId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}type-products/${typeProductId}`).pipe(map(response => {
            return response;
        }));
    }

    store(typeProduct: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}type-products`, typeProduct)
            .pipe(map(response => {
                return response;
            }));
    }

    update(typeProduct: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}type-products/${typeProduct.id}`, typeProduct)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}type-products/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
